import { flow } from "fp-ts/function";
import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { getExtractor } from "../extractor-infra";
const nodesAccessor = (node) => Array.isArray(node.nodes) ? node.nodes : [];
const getRootNode = (nodes) => Array.isArray(nodes) ? {
  id: "root",
  type: Node_Type.UNRECOGNIZED,
  nodes
} : nodes;
const extract = flow(
  getRootNode,
  getExtractor(nodesAccessor)
);
export {
  extract
};
//# sourceMappingURL=extract.js.map
